import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAgent } from '../contexts/AgentContext';
import { personaAPI, metadataAPI } from '../services/api';
import { useToast } from '../contexts/ToastContext';

export const useCommonData = () => {
    const [personas, setPersonas] = useState([]);
    const [metadata, setMetadata] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { currentWorkspace, isInitialized } = useAuth();
    const { agents, agentsLoading } = useAgent();
    const { showToast } = useToast();

    const fetchData = async () => {
        if (!isInitialized) return;

        if (!currentWorkspace) {
            showToast('No workspace selected', 'error');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const [personasResponse, metadataResponse] = await Promise.all([
                personaAPI.getAllPersonas(currentWorkspace.id),
                metadataAPI.getMetadata(currentWorkspace.id)
            ]);

            setPersonas(personasResponse.data || []);
            setMetadata(metadataResponse.data || []);
        } catch (err) {
            console.error('Error fetching common data:', err);
            setError(err.message || 'Failed to fetch data');
            showToast('Failed to fetch data', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [currentWorkspace, isInitialized]); // eslint-disable-line react-hooks/exhaustive-deps

    return {
        agents,
        personas,
        metadata,
        loading: loading || agentsLoading || !isInitialized,
        error,
        refetch: fetchData
    };
};
